import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableOrderConfigurationRoutes = Loadable(
  './OrderConfigurationRoutes',
  () => import(/* webpackChunkName: "OrderConfiguration" */ './OrderConfigurationRoutes'),
  () => [(require as any).resolveWeak('./OrderConfigurationRoutes')]
);
